import { getQueryParam } from "@/utils";

export function isDebugEnabled(): boolean {
	return getQueryParam("efDebugger")?.toLowerCase() === "true" || false;
}

let cachedDebugEnabled: boolean | null = null;

export function debugLog(...args: unknown[]): void {
	if (cachedDebugEnabled === null) {
		cachedDebugEnabled = isDebugEnabled();
	}

	if (!cachedDebugEnabled) return;
	console.log(...args);
}

export function debugWarn(...args: unknown[]): void {
	if (cachedDebugEnabled === null) {
		cachedDebugEnabled = isDebugEnabled();
	}

	if (!cachedDebugEnabled) return;
	console.warn(...args);
}

export function debugError(...args: unknown[]): void {
	if (cachedDebugEnabled === null) {
		cachedDebugEnabled = isDebugEnabled();
	}

	if (!cachedDebugEnabled) return;
	console.error(...args);
}
